import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ENVIRONMENT } from '../../../../environments/environment';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-control-input-user',
  templateUrl: './control-input-user.component.html',
  styleUrl: './control-input-user.component.scss',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ControlInputUserComponent,
      multi: true,
    },
  ],
})
export class ControlInputUserComponent implements ControlValueAccessor {
  @Input() formControlName = '';
  @Input() placeholder = '';
  @Output() userKeyup = new EventEmitter<KeyboardEvent>();

  value = '';
  iconsStyle = ENVIRONMENT.FONTAWESOME.style;
  iconSize = 'fa-lg';

  readonly icons = {
    user: 'fa-user',
  };

  onKeyup(event: KeyboardEvent): void {
    this.userKeyup.emit(event); // Emit the userKeyup event to the parent component
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (_value: string): void => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  getInputValue(event: Event): string {
    const target = event.target as HTMLInputElement;
    return target.value;
  }
}
